<template>
	<div class="packages-section" v-if="provider">
		<div class="packages-section-header">
			<p>All {{ provider.name }} Packages</p>
		</div><!-- end.packages-section-header -->
		<div class="packages-section-body" :class="`card-size-${cardSize}`">
			<package-card v-for="product in provider.products" :key="product.id" :provider-slug="provider.slug" :product="product" @click="packageClick(product)" />

		</div><!-- end.packages-section-body -->
	</div><!-- end.packages-section -->
</template>

<script>
	import PackageCard from './PackageCard.vue'
	export default {
		components: {
			PackageCard
		},
		props: ['provider'],
		data() {
			return {
				_recommended: false
			}
		},
		computed: {
			cardSize() {
				let productCount = this.provider.products.length;
				return productCount;
				switch(productCount) {
					case 1:
						return
				}

				if(productCount < 5) {
					return 'large';
				}

				if(productCount === 5) {
					return 'medium';
				}

				return 'small';
			},

		},
		methods: {
			packageClick(product) {
				this.$scrollTo('header');
				if (dataLayer) {
					dataLayer.push({
						event: 'Browse_Packages.Package.Click',
						speed: product.speed_up + '/' + product.speed_down, // 25/25
						provider: this.provider.name, // openserve
						price: product.price, // 597.00
					});
				}
			},

		}
	}
</script>
